import { render, staticRenderFns } from "./CreateRental.yaml?vue&type=template&id=1b16d719&component"
import script from "./CreateRental.yaml?vue&type=script&lang=ts&component"
export * from "./CreateRental.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports